import createTipoCotizacionForm from './createTipoCotizacionFormModel';
const {
  formField: {
    // DATOS PARAMETROS 
    name,
    description
  } 
} = createTipoCotizacionForm;


export default {

  [name.name]: '',
  [description.name]: '',
};

